// extracted by mini-css-extract-plugin
module.exports = {"svg":"WishListIcon_svg__hQgeI","black":"WishListIcon_black__aECHY","white":"WishListIcon_white__zcCxr","filled":"WishListIcon_filled__R9TV_"};